export default function DatePickerOverrides() {
  return {
    MuiPickersPopper: {
      styleOverrides: {
        paper: {
          backgroundColor: '#0E1720',
          color: '#FFFFFF',
          borderRadius: '16px',
          border: '1px solid #394047',
          boxShadow: '0 8px 24px rgba(0,0,0,0.4)',
        },
      },
    },
    MuiPickersDay: {
      styleOverrides: {
        root: {
          color: '#FFFFFF',
          borderRadius: '8px',
          '&.Mui-selected': {
            backgroundColor: '#1DB0BF',
            color: '#000',
          },
          '&:hover': {
            backgroundColor: 'rgba(29,176,191,0.2)',
          },
          '&.MuiPickersDay-today': {
            border: '1px solid rgba(29,176,191,0.7)',
          },
        },
      },
    },
    MuiPickersYear: {
      styleOverrides: {
        yearButton: {
          color: '#FFFFFF',
          '&.Mui-selected': {
            backgroundColor: '#1DB0BF',
            color: '#000',
          },
          '&:hover': {
            backgroundColor: 'rgba(29,176,191,0.15)',
          },
        },
      },
    },
    MuiPickersMonth: {
      styleOverrides: {
        monthButton: {
          color: '#FFFFFF',
          '&.Mui-selected': {
            backgroundColor: '#1DB0BF',
            color: '#000',
          },
          '&:hover': {
            backgroundColor: 'rgba(29,176,191,0.15)',
          },
        },
      },
    },
    MuiPickersCalendarHeader: {
      styleOverrides: {
        root: {
          color: '#A8B2D1',
        },
        labelContainer: {
          color: '#FFFFFF',
        },
        switchViewButton: {
          color: '#FFFFFF',
          '&:hover': {
            color: '#1DB0BF',
          },
        },
      },
    },
    MuiPickersArrowSwitcher: {
      styleOverrides: {
        button: {
          color: '#FFF',
          '&:hover': {
            color: '#1DB0BF',
          },
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          color: '#A8B2D1',
        },
      },
    },
  };
}
